import { Box, Grid } from "@mui/material";
import IncidentsTable from "../../components/Fleet/IncidentsTable/IncidentsTable";
import IncidentPopup from "../../components/Fleet/IncidentPopup/IncidentPopup";
import { useEffect } from "react";
import { apiVariable } from "../../api/apiVariable";
import * as signalR from "@microsoft/signalr";
import useAuth from "../../hooks/useAuth";
import { useQueryClient } from "@tanstack/react-query";
import "../../assets/styles/pages/Fleet/incidentsPage.css";
import GenerateAllAssetRepairsButton from "../../components/Fleet/GeneratePdfButtons/GenerateAllAssetRepairsButton/GenerateAllAssetRepairsButton";
const IncidentsPage: React.FC = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    const incidentConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${apiVariable}/incidentHub`, {
        accessTokenFactory: () => token || "",
        withCredentials: false,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.None)
      .build();

    incidentConnection.on("IncidentUpdated", () => {
      queryClient.invalidateQueries({ queryKey: ["incidents"] });
      queryClient.invalidateQueries({ queryKey: ["asset"] });
    });

    incidentConnection.start();

    return () => {
      incidentConnection.stop();
    };
  }, [token, queryClient]);

  return (
    <Box className="incidents-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "600px" }}
            >
              <Grid item>
                <IncidentPopup />
              </Grid>
              <Grid item>
                <GenerateAllAssetRepairsButton
                  token={token}
                  incidentsRepairsOnly={true}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <IncidentsTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default IncidentsPage;
